module.exports = __webpack_public_path__ + "img/glue.be5030ca.webp";